import Text from '@ingka/text';
import { appConfig } from 'appConfig';
import { Stack, Page } from 'components/layout';
import React from 'react';

export const AboutPage = () => (
  <Page>
    <Stack>
      <Text tagName="h2">Welcome to Food EUDR DDS Support Application.</Text>
    </Stack>
  </Page>
);
